import { Injectable } from '@angular/core';
import { AppConfig } from './config.model';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  public config!: AppConfig;

  public load(): Promise<void> {
    const path = `assets/config/config.json`;
    return new Promise<void>((resolve, reject) => {
      fetch(path)
        .then((resp) => {
          resp.json().then((data) => {
            this.config = data;
            resolve();
          });
        })
        .catch((response: any) => {
          reject(`Could not load file '${path}': ${JSON.stringify(response)}`);
        });
    });
  }
}
